import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { VhRatingComponent } from '../rating/rating.component';

/**
 * "N★ & up" filter. Renders a radio list so only one threshold is
 * active at a time; parent owns the value.
 */
@Component({
  selector: 'vh-rating-filter',
  standalone: true,
  imports: [VhRatingComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ul class="vh-rating-filter" role="radiogroup" [attr.aria-label]="ariaLabel()">
      @for (threshold of thresholds; track threshold) {
        <li class="vh-rating-filter__item">
          <label>
            <input
              type="radio"
              name="vh-rating-filter"
              [value]="threshold"
              [checked]="value() === threshold"
              (change)="select(threshold)"
            />
            <vh-rating [value]="threshold" size="sm" />
            <span class="vh-rating-filter__label">&amp; up</span>
          </label>
        </li>
      }
      <li class="vh-rating-filter__item">
        <label>
          <input
            type="radio"
            name="vh-rating-filter"
            [value]="null"
            [checked]="value() === null"
            (change)="select(null)"
          />
          <span class="vh-rating-filter__label">Any rating</span>
        </label>
      </li>
    </ul>
  `,
  styleUrl: './rating-filter.component.scss',
})
export class VhRatingFilterComponent {
  readonly value = input<number | null>(null);
  readonly ariaLabel = input<string>('Minimum rating');

  readonly valueChange = output<number | null>();

  protected readonly thresholds = [4, 3, 2, 1] as const;

  select(threshold: number | null): void {
    this.valueChange.emit(threshold);
  }
}
